import { useLocation } from 'react-router-dom';

const TITLES: Record<string, string> = {
  '/': '首页',
  '/settings/invitation-policy': '邀请码策略',
  '/settings/invitation-rules': '邀请规则',
  '/settings/captcha': '人机验证',
  '/settings/ocr': 'OCR 识别配置',
  '/settings/verification-email': '验证码邮件',
  '/settings/commission-policy': '邀请奖励策略',
  '/settings/newcomer-reward': '新人注册奖励',
  '/settings/markets': '市场配置',
  '/settings/withdrawal-policy': '提现策略',
  '/settings/withdrawal-payout': '自动打款设置',
  '/settings/home-content': '首页内容配置',
  '/settings/customer-service': '在线客服配置',
  '/settings/faq': '常见问题配置',
  '/settings/app-update': 'App 更新配置',
  '/settings/apple-auth': 'Apple 登录配置',
  '/settings/message-review': '短信审核配置',
  '/settings/legal-documents': '法律文档',
  '/agents': '商户管理',
  '/agent-finance': '商户资金',
  '/agent-task-settings': '商户任务设置',
  '/agent-tasks': '全部商户任务',
  '/agent-feedback': '商户帮助与反馈',
  '/agent-task-reviews': '商户任务发布审核',
  '/agent-reports': '商户在线报表',
  '/agent-audit': '商户审计日志',
  '/advertising': '广告管理',
  '/advertising/new': '创建广告',
  '/advertising/reviews': '广告发布审核',
  '/advertising/slots': '广告位配置',
  '/advertising/reports': '广告统计报表',
  '/admin-accounts': '后台账号',
  '/users': '用户管理',
  '/tasks': '任务管理',
  '/rewards': '奖励记录',
  '/tasks/create': '创建任务',
  '/assignments': '会员提交审核',
  '/withdrawals': '提现管理',
  '/withdrawal-accounts': '提现账号管理',
  '/download-only-task-users': '下载任务限制名单',
  '/support-feedback': '客服反馈',
  '/invitation/codes': '邀请码管理',
  '/commissions': '邀请奖励记录',
  '/team': '团队查询',
  '/system-logs': '系统日志',
};

function getTitle(pathname: string): string {
  if (/^\/advertising\/\d+$/.test(pathname)) return '广告详情与审核';
  if (/^\/agent-feedback\/\d+$/.test(pathname)) return '商户反馈详情';
  if (/^\/agents\/\d+$/.test(pathname)) return '商户详情';
  if (/^\/agent-(tasks|task-reviews)\/\d+$/.test(pathname)) return '商户任务详情与审核';
  if (TITLES[pathname]) return TITLES[pathname];
  if (/^\/users\/\d+$/.test(pathname)) return '用户详情';
  if (/^\/tasks\/\d+$/.test(pathname)) return '任务详情';
  return '管理后台';
}

export function TopBar({ navigationOpen, onOpenNavigation }: { navigationOpen: boolean; onOpenNavigation: () => void }) {
  const { pathname } = useLocation();
  const title = getTitle(pathname);

  return (
    <header className="h-14 px-4 md:px-6 gap-3 flex items-center border-b border-border bg-white shrink-0">
      <button type="button" aria-label="打开导航" aria-expanded={navigationOpen} aria-controls="admin-mobile-navigation" onClick={onOpenNavigation} className="md:hidden shrink-0 h-9 w-9 rounded border border-border text-xl leading-none focus-visible:outline-2 focus-visible:outline-primary">☰</button>
      <h1 className="text-lg md:text-xl font-semibold text-gray-900">{title}</h1>
    </header>
  );
}
